















import { Note } from "../../models/Note";
import { NoteApi } from "../../api/NoteApi";

export default {
    name: "NoteEdit",
    props: {
        note: Note,
    },
    data() {
        return {
            NoteApi: new NoteApi(),
        };
    },
    methods: {
        cancel: function () {
            this.note.content = "";
            localStorage.removeItem("postit-content");
            this.$emit("close-modal");
        },
        save: function () {
            let self = this;
            self.NoteApi.save(self.note).then((response) => {
                localStorage.removeItem("postit-content");
                self.$emit("close-modal");
            });
        },
    },
    watch: {
        "note.content": function (val) {
            localStorage.setItem("postit-content", val);
            let textarea = document.getElementById("postit-content");
            textarea.style.height = ""; /* Reset the height*/
            textarea.style.height = textarea.scrollHeight + "px";
        },
    },
};
